<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">업무전달</span>
            <span class="txt">직원 간 업무를 전달 할 수 있도록 글을 작성할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :select-data="['진행여부', '진행중', '처리완료']"
                    :select-value="['', 'O', 'C']"
                    @update:set="
                        (val) => {
                            searchType = val;
                            onSearchList();
                        }
                    "
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
                <div class="com-search-input">
                    <input v-model="searchStr" placeholder="제목+내용" type="text" v-on:keyup.enter="onEventSearch" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link :to="'/madmin/board/edit'" class="com-btn blue">글 등록</router-link>
                </div>
            </div>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 100px" />
                    <col style="width: 520px" />
                    <col style="width: 140px" />
                    <col style="width: 120px" />
                    <col style="width: 225px" />
                    <col style="width: 130px" />
                    <col style="width: 80px" />
                    <col style="width: 155px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>상태</th>
                        <th>제목</th>
                        <th>글쓴이</th>
                        <th>참석팀</th>
                        <th>참석자</th>
                        <th>등록일자</th>
                        <th>조회</th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in workList" :key="index">
                        <td>
                            <span v-if="item.status_cd === 'O'" class="red">
                                진행중 (0/{{ item.join_staff_count }})
                            </span>
                            <template v-if="item.status_cd === 'C'">
                                처리완료({{ item.join_staff_count }}/{{ item.join_staff_count }})
                            </template>
                        </td>
                        <td class="left">
                            <!-- <router-link :to="`/madmin/board/detail/${item.center_id}/${item.center_task_id}`" class="link">{{ item.title }}</router-link> -->
                            <a
                                class="link"
                                style="cursor: pointer"
                                @click="routing(item.center_id, item.center_task_id)"
                            >
                                {{ item.title }}
                            </a>
                        </td>
                        <td>{{ item.writor }}</td>
                        <td>{{ item.join_team_nm }}</td>
                        <td>
                            {{ item.join_staff_name }}
                            <template v-if="item.join_staff_count > 1">외 {{ item.join_staff_count - 1 }}명</template>
                        </td>
                        <td>{{ item.cre_dt | timestampFilter }}</td>
                        <td>{{ item.view_cnt }}</td>
                        <td>
                            <!-- <button class="com-btn" v-if="centerStaffId == item.center_staff_id">수정</button> -->
                            <router-link
                                v-if="hasAuth(item.center_staff_id)"
                                :to="`/madmin/board/edit/${item.center_id}/${item.center_task_id}`"
                                class="com-btn"
                            >
                                수정
                            </router-link>
                            <button
                                v-if="hasAuth(item.center_staff_id)"
                                class="com-btn red"
                                @click="onDeleteList(item.center_task_id)"
                            >
                                삭제
                            </button>
                        </td>
                    </tr>
                    <tr v-if="workList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>

                    <!--
                <tr>
                    <td><span class="red">진행중 (2/5)</span></td>
                    <td class="left">
                        <a href="#" class="link">2월 10일 스터디 안내</a>
                    </td>
                    <td>김윤경</td>
                    <td>센터관리자</td>
                    <td>김하연 외 4명</td>
                    <td>2019.08.20</td>
                    <td>2</td>
                    <td>
                        <button class="com-btn">수정</button>
                        <button class="com-btn red">삭제</button>
                    </td>
                </tr>
                <tr>
                    <td>처리완료(1/1)</td>
                    <td class="left">
                        <a href="#" class="link">2월 10일 스터디 안내</a>
                    </td>
                    <td>김윤경</td>
                    <td>센터관리자</td>
                    <td>김하연 외 4명</td>
                    <td>2019.08.20</td>
                    <td>2</td>
                    <td>
                        <button class="com-btn">수정</button>
                        <button class="com-btn red">삭제</button>
                    </td>
                </tr>
                --></tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import EventBus from '../../../assets/js/eventBus';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';
export default {
    name: 'BoardList',
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
            centerStaffId: 'auth/staffId',
        }),
    },
    data() {
        return {
            centerTaskId: '',
            isLoading: false,
            workList: [],
            searchStr: '',
            searchType: '',
            sortTypeList: ['10줄보기', '20줄보기', '50줄보기', '100줄보기'],
            sortTypeValueList: [10, 20, 50, 100],
            administrator: 0,
            pagingInfo: { ...pagingInfo },
        };
    },
    /*
    beforeMount() {
        let { centerId, uid } = JSON.parse(localStorage.getItem("userInfo"));
        if (!centerId)
            alert("센서정보를 읽어올 수 없습니다. 다시 로그인해주십시오.");
        this.centerId = centerId;
        this.centerStaffId = uid;
    },
    */
    mounted() {
        this.getRoleList(this.centerId);
    },
    activated() {
        this.onSearchList();
    },
    methods: {
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getWorkList();
                this.setPageParams(data);
                this.workList = data.items;
                this.isLoading = false;
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        getWorkList() {
            return api.get('admin/api/centerTask/all', {
                params: {
                    centerId: this.centerId,
                    title: this.searchStr,
                    status: this.searchType,
                    searchStr: this.searchStr,
                    ...this.pagingInfo,
                },
            });
        },

        // 검색어 입력 처리
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },

        // 검색 조건 초기화
        resetSearchContent() {
            this.searchType = '';
            this.onSearchList();
            EventBus.$emit('event:initList', 'init');
        },

        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 리스트 삭제하기
        async onDeleteList(centerTaskId) {
            try {
                if (confirm('삭제하시겠습니까?') == true) {
                    console.log(centerTaskId);
                    this.centerTaskId = centerTaskId;
                    const data = await this.deleteList();
                    this.onSearchList();
                } else {
                    alert('삭제가 취소되었습니다.');
                    this.onSearchList();
                }
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        deleteList() {
            return api.delete(`/admin/api/centerTask/delete/${this.centerId}/${this.centerTaskId}`);
        },
        hasAuth(staffId) {
            let answer = false;

            const admin = parseInt(this.administrator[0].roleId, 10);
            const login = parseInt(this.centerStaffId, 10);
            const listStaff = parseInt(staffId, 10);
            const loginRoleId = parseInt(this.$store.state.auth.user.roleId, 10);

            if (login === listStaff) {
                answer = true;
            } else if (admin === loginRoleId) {
                answer = true;
            }

            return answer;
        },
        async routing(centerId, centerTaskId) {
            await this.$router.push(`/madmin/board/detail/${centerId}/${centerTaskId}`);
        },
        async getRoleList(id) {
            await api
                .get(`/admin/api/centerStaffRole/${id}/all`)
                .then((res) => {
                    this.administrator = res.data.filter((val) => val.roleSeq === 0);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style lang="scss"></style>
